import { useEffect, useState } from 'react';
import { handleError } from '../../../components/errors/errorHandling';
import { FormModel } from '../../../models/form/form';
import { OrganizationModel } from '../../../models/organization/organization';
import { getFormDetailsById } from '../../../services/form/FormService';

const useForm = (organizationId: string, formId?: string | undefined) => {
  const [id, setFormId] = useState(formId);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [form, setForm] = useState<FormModel>();
  const [organization, setOrganization] = useState<OrganizationModel>();
  const [orgId, setOrganizationId] = useState<string>(organizationId);

  useEffect(() => {
    if (!id || !orgId) {
      // TODO Set invalid properties
      return;
    }
    setIsLoading(true);
    loadAsync();
  }, [id, orgId]);

  const loadAsync = async () => {
    try {
      const formDetails = await getFormDetailsById(orgId, id);
      const { form, organization } = formDetails.data;

      const formResult: FormModel = {
        ...form,
        content: JSON.parse(form.content),
      };

      setForm(formResult);
      setOrganization(organization);
    } catch (error) {
      handleError(error);
    }

    setIsLoading(false);
  };

  return { form, organization, setFormId, isLoading, setForm, setOrganizationId };
};

export default useForm;
